"use strict";
exports.getDayOfYear = getDayOfYear;
var _index = require("./differenceInCalendarDays.js");
var _index2 = require("./startOfYear.js");
var _index3 = require("./toDate.js");
function getDayOfYear(date) {
  const _date = (0, _index3.toDate)(date);
  const diff = (0, _index.differenceInCalendarDays)(
    _date,
    (0, _index2.startOfYear)(_date)
  );
  const dayOfYear = diff + 1;
  return dayOfYear;
}
